<template>
  <div>
    <v-card outlined class="pt-4 pb-6 pl-4 pr-3  pricingPlanCard">
      <div class="mt-4">
        <small>
          <v-layout v-for="(feature, featureIndex) in features" :key="featureIndex" wrap mt-2 justify-space-around>
            <v-flex xs1>
              <v-icon small class="secondary--text">mdi-check</v-icon>
            </v-flex>
            <v-flex xs10 v-if="featureIndex === 0"><b>{{feature}}</b></v-flex>
            <v-flex xs10 v-else>{{feature}}</v-flex>
          </v-layout>
        </small>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  // props: {
  //   numberOfDossiersPerMonth: Number,
  // },
  computed: {
    features() {
      return [
        // `${this.numberOfDossiersPerMonth} ${this.$t('k')}`, 
        this.$t('l'),
        this.$t('n'),
        this.$t('s'),
        this.$t('t1'),
        this.$t('t2'),
        this.$t('o'),
        this.$t('p'),
        this.$t('q'),
        this.$t('r'),
      ]
    },
  }
}
</script>

<style scoped>
  .pricingPlanCard {
    border-radius: 4px
  }
</style>

<i18n>
{
  "fr": {
    "k": "dossiers par mois",
    "l": "Template de dossier à votre format",
    "s": "Invitation du candidat à créer lui-même son dossier",
    "t1": "Création du dossier à partir de n'importe quel CV",
    "t2": "Création du dossier à partir du CV LinkedIn",
    "n": "Nombre d'utilisateurs illimité",
    "o": "Base de données centralisée des dossiers de l'entreprise",
    "p": "Recherche de dossiers par mots-clefs & technologies",
    "q": "Traduction automatique du CV",
    "r": "Support premium"
  },
  "en": {
    "k": "CVs per month",
    "l": "Custom CV template",
    "s": "Invite candidate to transform himself his CV",
    "t1": "Transform any type of CV",
    "t2": "Transform LinkedIn CVs",
    "n": "Unlimited number of users",
    "o": "Shared database of CVs across the company",
    "p": "Search engine for CVs",
    "q": "Automatic CV translation",
    "r": "Premium support"
  }
}
</i18n>